module.exports = __webpack_public_path__ + "img/infoq-intro-h5.49d0c589.png";